var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"cookie"},[_c('div',{staticClass:"cookie-text"},[_vm._v(" This website uses cookies to ensure you get the best experience on our website "),_c('router-link',{staticClass:"link",attrs:{"to":"/privacy"}},[_vm._v("More info")])],1),_c('div',{staticClass:"btn",on:{"click":_vm.gotIt}},[_vm._v("Got it!")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }